export default class QuantitySelector {
    constructor() {
        window.addEventListener('load', QuantitySelector.init);
        jQuery(document.body).on('updated_cart_totals', QuantitySelector.init);
    }

    static init() {
        document
            .querySelectorAll('.quantity-selector__button--plus')
            .forEach((selector) => selector.addEventListener('click', (e) => QuantitySelector.increment(e)));

        document
            .querySelectorAll('.quantity-selector__button--minus')
            .forEach((selector) => selector.addEventListener('click', (e) => QuantitySelector.decrement(e)));
    }

    static increment(e) {
        const input = e.target.parentElement.querySelector('input');
        const inputValue = input.value;

        if (parseInt(input.value, 10) < parseInt(input.max, 10)) {
            input.value = parseInt(inputValue, 10) + 1;
            document.querySelector('button[name="update_cart"]').disabled = false;
        }
    }

    static decrement(e) {
        const input = e.target.parentElement.querySelector('input');
        const inputValue = input.value;

        if (parseInt(input.value, 10) > parseInt(input.min, 10)) {
            input.value = parseInt(inputValue, 10) - 1;
            document.querySelector('button[name="update_cart"]').disabled = false;
        }
    }
}
